export default "query mediums{\n    mediums\n}";